import { memo } from 'react';
import './MfaButton.scss';
import CheckBox from './CheckBox';

export type MFAMethodType = 'sms' | 'email';

interface MFAMethodButtonProps {
  method: MFAMethodType;
  label: string;
  value?: string;
  isSelected: boolean;
  isMethodUpdating: boolean;
  onSelect: (method: MFAMethodType) => void;
  icon: string;
  showUnselectedState?: boolean;
}

const MFAMethodButton = ({
  method,
  label,
  value,
  isSelected,
  isMethodUpdating,
  onSelect,
  icon,
}: MFAMethodButtonProps) => {
  const baseClasses = {
    button: `method-button ${isSelected ? 'method-button--active' : ''} ${
      isMethodUpdating ? 'method-button--disabled' : ''
    }`.trim(),
    imageContainer: `image-container ${isSelected ? 'image-container--active' : ''}`.trim(),
    icon: `method-icon ${isSelected ? 'method-icon--active' : ''}`.trim(),
  };

  const handleSelect = () => {
    if (!isMethodUpdating) {
      onSelect(method);
    }
  };

  return (
    <button
      className={baseClasses.button}
      onClick={handleSelect}
      disabled={isMethodUpdating}
      type='button'
    >
      <div className='method-content'>
        <div className={baseClasses.imageContainer}>
          <img src={icon} alt={`${method} icon`} className={baseClasses.icon} />
        </div>
        <div className='method-text-container'>
          <span className='method-type'>{label}</span>
          {value && <span className='method-value'>{value}</span>}
        </div>
      </div>
      <CheckBox isActive={isSelected} hasValue={Boolean(value)} />
    </button>
  );
};

export default memo(MFAMethodButton);
